import React from 'react'

const Servicing = ({fill}) => {
  return (
    <svg
      width={fill ? "70":"68"}
      height="90"
      viewBox={fill ? "1 0 66 60":"0 0 68 62"}
      fill={"none" || fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 1000003880">
        <g id="Group">
          <path
            id="Vector"
            d="M51.9122 26.5964C50.7656 26.4854 49.6235 26.3283 48.4784 26.2003C48.2278 26.1723 48.0878 26.0588 48.0015 25.8209C47.856 25.4201 47.7042 25.0182 47.5107 24.6394C47.3685 24.3612 47.4217 24.1706 47.6055 23.9421C48.32 23.0539 49.0194 22.1536 49.7216 21.2557C50.4039 20.3832 50.3577 19.537 49.581 18.7571C48.3831 17.5544 47.1827 16.3542 45.9805 15.1559C45.1848 14.3627 44.3442 14.3221 43.453 15.0236C42.5471 15.7366 41.6363 16.4436 40.7358 17.1634C40.5387 17.3209 40.3679 17.3502 40.1368 17.2386C39.7647 17.0588 39.3854 16.8856 38.9935 16.7576C38.675 16.6535 38.5496 16.4782 38.5158 16.1472C38.3988 15.001 38.2601 13.8568 38.112 12.7141C37.98 11.6949 37.3191 11.1247 36.2945 11.1233C34.5841 11.1209 32.8738 11.1219 31.1633 11.1229C30.0497 11.1236 29.4008 11.7114 29.2763 12.8136C29.1469 13.9585 29.0035 15.102 28.8754 16.2471C28.8475 16.4967 28.7374 16.6382 28.498 16.7249C28.0972 16.87 27.697 17.0255 27.3175 17.218C27.0414 17.358 26.8493 17.31 26.6193 17.1248C25.7213 16.402 24.8111 15.6943 23.9021 14.9851C23.0661 14.3329 22.2117 14.3812 21.4629 15.1184C21.1859 15.3911 18.0469 18.5316 17.8481 18.7321C17.0341 19.5532 16.9904 20.374 17.7087 21.2877C18.4132 22.1839 19.1119 23.0847 19.8235 23.9751C19.9879 24.1809 20.0326 24.3584 19.9087 24.6068C19.7243 24.9764 19.5556 25.358 19.4265 25.7497C19.3265 26.0533 19.16 26.1774 18.8451 26.2104C17.6993 26.3301 16.5553 26.4691 15.412 26.6125C14.3728 26.7429 13.7992 27.4011 13.7981 28.4492C13.7961 30.1466 13.797 31.844 13.7977 33.5415C13.7983 34.6973 14.3904 35.3347 15.5427 35.4583C16.6754 35.5797 17.8054 35.7267 18.9374 35.8552C19.1703 35.8817 19.309 35.9854 19.3925 36.2082C19.5467 36.6197 19.7059 37.0312 19.8978 37.4258C20.0237 37.6847 19.9927 37.8704 19.815 38.0914C19.1087 38.9694 18.4204 39.862 17.7233 40.7475C16.9867 41.6832 17.0275 42.4987 17.8594 43.3319C19.0405 44.5147 20.2221 45.697 21.4054 46.8776C22.2226 47.6929 23.0517 47.7374 23.9613 47.0219C24.8573 46.3173 25.758 45.6185 26.6485 44.9069C26.8533 44.7433 27.0305 44.6959 27.2801 44.8172C27.6749 45.009 28.0831 45.1773 28.4963 45.3258C28.756 45.4192 28.8502 45.5823 28.8794 45.8423C28.9963 46.8844 29.1726 47.9219 29.2416 48.9667C29.3046 49.9201 29.6901 50.5865 30.5918 50.9314H36.8119C37.7322 50.5809 38.1027 49.8902 38.1665 48.93C38.235 47.8988 38.4103 46.8751 38.5229 45.8464C38.5537 45.5654 38.6674 45.4086 38.9397 45.3152C39.3423 45.177 39.7399 45.0157 40.1209 44.8265C40.3685 44.7037 40.542 44.7353 40.7506 44.9023C41.6395 45.6145 42.5407 46.3112 43.4352 47.0163C44.3561 47.7424 45.1824 47.6951 46.0189 46.86C47.1917 45.689 48.3638 44.5173 49.5344 43.3442C50.3695 42.5075 50.4179 41.6836 49.692 40.76C48.988 39.8645 48.2896 38.9646 47.5779 38.0753C47.4124 37.8684 47.3759 37.6913 47.4962 37.4439C47.6879 37.0494 47.8516 36.6399 48.003 36.2279C48.0906 35.9895 48.234 35.8809 48.483 35.8531C49.6273 35.7254 50.7685 35.5687 51.9142 35.4572C52.7735 35.3734 53.2974 34.9039 53.6064 34.137V27.9169C53.2973 27.1488 52.7727 26.6798 51.9122 26.5964Z"
            stroke={fill ? fill : "#211E24"}
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            id="Vector_2"
            d="M33.7016 40.1232C38.7256 40.1232 42.7983 36.0505 42.7983 31.0266C42.7983 26.0026 38.7256 21.9299 33.7016 21.9299C28.6777 21.9299 24.605 26.0026 24.605 31.0266C24.605 36.0505 28.6777 40.1232 33.7016 40.1232Z"
            stroke={fill ? fill : "#211E24"}
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
        </g>
        <path
          id="Vector_3"
          d="M4.37866 25.4793C7.44451 12.1903 18.2021 2.39706 30.5866 1.13817C45.6773 -0.395836 60.7181 10.9922 63.5834 27.8741"
          stroke={fill ? fill : "#211E24"}
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          id="Vector_4"
          d="M63.6161 35.2549C61.0219 49.1834 49.8478 59.6087 36.8475 60.8709C21.559 62.3552 6.57376 50.8925 3.85059 34.135"
          stroke={fill ? fill : "#211E24"}
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          id="Vector_5"
          d="M1.34937 21.3584L3.93561 27.8638C5.51354 26.258 7.09156 24.6523 8.66949 23.0466"
          stroke={fill ? fill : "#211E24"}
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          id="Vector_6"
          d="M66.6504 39.4109L64.0642 32.9055C62.4863 34.5113 60.9083 36.117 59.3303 37.7227"
          stroke={fill ? fill : "#211E24"}
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
      </g>
    </svg>
  );
}

export default Servicing
